//region block: pre-declaration
//endregion
function set_animationsEnabled(_set____db54di) {
  animationsEnabled = _set____db54di;
}
function get_animationsEnabled() {
  return animationsEnabled;
}
var animationsEnabled;
function get_areAnimationsEnabled(_this__u8e3s4) {
  return animationsEnabled;
}
//region block: init
animationsEnabled = true;
//endregion
//region block: exports
export {
  get_animationsEnabled as get_animationsEnabled25ujr8oia8gbs,
  set_animationsEnabled as set_animationsEnabled1ac1lbh50s602,
  get_areAnimationsEnabled as get_areAnimationsEnabled315dhlyuxowng,
};
//endregion

//# sourceMappingURL=Element.ext.js.mjs.map
